import {
    CONFIRMED_CREATE_DOCUMENT_ACTION,
    CONFIRMED_DELETE_DOCUMENT_ACTION,
    CONFIRMED_EDIT_DOCUMENT_ACTION,
    CONFIRMED_GET_DOCUMENTS,
    CREATE_DOCUMENT_ACTION,    
    CREATE_DOCUMENT_ERROR_ACTION,
    CLEAR_DOCUMENT_ERROR,
    LOADING_DOCUMENTS,
    LOADING_TOGGLE_ACTION
} from '../actions/DocumentTypes';

const initialState = {
    documents: [],
    loading: false,
    createDocumentError: {}
};

export default function DocumentReducer(state = initialState, actions) {
    if (actions.type === CREATE_DOCUMENT_ACTION) { 
        return {
            ...state,
            documents: [...state.documents],
        };
    }

    if (actions.type === CONFIRMED_DELETE_DOCUMENT_ACTION) {
        const documents = state.documents.filter(document => document.id !== actions.payload);
        return {
            ...state,
            documents,
        };
    }

    if (actions.type === CONFIRMED_EDIT_DOCUMENT_ACTION) {
        const documents = state.documents.map(document => 
            document.id === actions.payload.id ? actions.payload : document
        );
        return {
            ...state,
            documents,
        };
    }

    if (actions.type === CONFIRMED_CREATE_DOCUMENT_ACTION) {
        return {
            ...state,
            documents: [...state.documents, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_DOCUMENTS) {
        return {
            ...state,
            documents: actions.payload,
        };
    }

    if (actions.type === LOADING_DOCUMENTS) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === CREATE_DOCUMENT_ERROR_ACTION) {
        return {
            ...state,
            createDocumentError: actions.payload,
        };
    }

    if (actions.type === CLEAR_DOCUMENT_ERROR) {
        return {
            ...state,
            createDocumentError: {},
        };
    }
    if (actions.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            loading: actions.payload,
        };
    }
    return state;
}
